import './styles.css.js';
import { Flex } from '@magnetic/flex';
import React, { createContext } from 'react';
import { useNavContext } from '../nav-context.js';
import { NavDrawerHeading } from './heading.js';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const NavDrawerContentContext = createContext({
  density: "comfy",
  itemGroupSpacing: 24
});
const NavDrawerContent = /* @__PURE__ */ __name(({
  children,
  density = "compact",
  heading,
  id,
  itemGroupSpacing = 24,
  onBackClick,
  ...props
}) => {
  const { openId, openLabel } = useNavContext();
  if (id !== openId) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(NavDrawerContentContext.Provider, {
    value: { density, itemGroupSpacing }
  }, /* @__PURE__ */ React.createElement(NavDrawerHeading, {
    heading: heading != null ? heading : openLabel,
    onBackClick
  }), /* @__PURE__ */ React.createElement(Flex, {
    className: "mds-nav-drawer-content",
    direction: "vertical",
    ...props
  }, children));
}, "NavDrawerContent");

export { NavDrawerContent, NavDrawerContentContext };
//# sourceMappingURL=content.js.map
